import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    OpenApiGenerateAISeoForPageMethod,
    type OpenApiGenerateAISeoForPageRequest,
    type OpenApiGenerateAISeoForPageResponseSuccess,
    OpenApiGenerateAISeoForPageUrl,
    OpenApiGetPageContextMethod,
    type OpenApiGetPageContextRequest,
    type OpenApiGetPageContextResponseSuccess,
    OpenApiGetPageContextUrl,
    type OpenApiGetPageVariantsByAliasPathParameters,
    type OpenApiGetPageVariantsByAliasResponseSuccess,
} from '#shared/api/schema';

export const PageTemplatesTag = 'PageTemplates' as const;

export const api = createApi({
    name: 'entities/constructor/api/page/api',
    tagTypes: [PageTemplatesTag],
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            getPageTemplates: builder.query<
                OpenApiGetPageVariantsByAliasResponseSuccess,
                OpenApiGetPageVariantsByAliasPathParameters
            >({
                query: ({ page_alias }) => {
                    return {
                        url: `/pages/variants/${page_alias}`,
                        method: 'GET',
                    };
                },
                providesTags: [PageTemplatesTag],
            }),
            clearConstructorPageTemplatesCache: builder.mutation<{}, void>({
                queryFn: () => {
                    return { data: {} };
                },
                invalidatesTags: [PageTemplatesTag],
            }),
            generateAISeoForPage: builder.mutation<
                OpenApiGenerateAISeoForPageResponseSuccess,
                { page_id: string } & OpenApiGenerateAISeoForPageRequest
            >({
                query: ({ page_id, ...body }) => {
                    return {
                        url: OpenApiGenerateAISeoForPageUrl.replace('{page_id}', encodeURIComponent(page_id)),
                        method: OpenApiGenerateAISeoForPageMethod,
                        body,
                    };
                },
            }),
            getPageContext: builder.mutation<OpenApiGetPageContextResponseSuccess, OpenApiGetPageContextRequest>({
                query: (body) => {
                    return {
                        url: OpenApiGetPageContextUrl,
                        method: OpenApiGetPageContextMethod,
                        body,
                    };
                },
            }),
        };
    },
});

export const useGetConstructorPageTemplates = api.useGetPageTemplatesQuery;
export const clearConstructorPageTemplatesCache = api.endpoints.clearConstructorPageTemplatesCache.mutate;
export const generateAISeoForConstructorPage = api.endpoints.generateAISeoForPage.mutate;
export const getConstructorPageContext = api.endpoints.getPageContext.mutate;
